import { Grid2 as Grid, Typography } from '@mui/material'
import Banner from 'components/Banner'
import { IPatientVitalSignsResponse } from 'types/patient/types'
import { useBannerData } from 'utils/hda'

interface HDABannerProps {
  vitalSigns: IPatientVitalSignsResponse
}

const HDABanner: React.FC<HDABannerProps> = ({ vitalSigns }) => {
  const vsList: Array<string> = useBannerData(vitalSigns)

  if (vsList.length == 0) {
    return <></>
  }

  const titleComplement =
    vsList.length == 1
      ? 'O sinal vital abaixo está'
      : 'Os sinais vitais abaixo estão'

  return (
    <Grid container mb={2}>
      <Grid size={12}>
        <Banner
          variant='filled'
          sx={{
            backgroundColor: `rgba(218, 204, 62, 1.0)`
          }}
        >
          <Typography variant='h5' fontWeight='bold' fontSize={'16pt'}>
            {titleComplement} fora dos padrões estabelecidos para o estudo. Por
            favor, peça ao paciente refazer as medições manualmente e, caso
            necessário, acionar o médico responsável.
          </Typography>
          <Typography variant='subtitle1' fontWeight='bold'>
            <ul>
              {vsList.map((item, index) => (
                <li key={`banner-hda-${index + 1}`}>{item}</li>
              ))}
            </ul>
          </Typography>
        </Banner>
      </Grid>
    </Grid>
  )
}

export default HDABanner
